import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-financial-header',
  templateUrl: './financial-header.component.html',
  styleUrls: ['./financial-header.component.scss']
})
export class FinancialHeaderComponent implements OnInit {
  @Input()
  isFullFactSheet;
  @Input()
  printPage;
  financial_highlight;
  period: String;
  account_period: String = 'Calendar year (Consolidated**)';
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/financial-header/financial-header.component.ts